<template lang="pug">
.v-peculiarities.peculiarities(v-if="peculiarities")
	.peculiarities__container
		.peculiarities__wrap
			.peculiarities__top
				.peculiarities__top-title(v-if="peculiarities.title") {{peculiarities.title}}
				.peculiarities__top-main
					template(v-if="peculiarities.items && peculiarities.items.length"
							v-for="(peculiarity, peculiarityIndex) in peculiarities.items"
							:key="peculiarityIndex")
						.peculiarities__main-item
							img.peculiarities__item-icon(v-if="peculiarity.icon"
									loading="lazy"
									alt=""
									:src="peculiarity.icon")
							template(v-if="isXs")
								.peculiarities__item-text(v-if="peculiarity.text"
									:class="{'peculiarities__item-text--dotted': peculiarity.tooltip}"
									@click="openModal(peculiarity.tooltip)") {{peculiarity.text}}
							template(v-else)
								.peculiarities__item-text(v-if="peculiarity.text"
										:class="{'peculiarities__item-text--dotted': peculiarity.tooltip}")
									| {{peculiarity.text}}
									.peculiarities__item-tooltip-wrap(v-if="peculiarity.tooltip")
										.peculiarities__item-tooltip
											.peculiarities__item-tooltip-text.scrollbar(v-if="peculiarity.tooltip" v-html="peculiarity.tooltip")
			.peculiarities__middle(v-if="peculiarities.btn")
				a.peculiarities__btn(v-if="peculiarities.btn.text"
						:href="peculiarities.btn.link"
						target="_blank"
						:class="peculiarities.btn.className || ''") {{peculiarities.btn.text}}
					v-svg-icon.params__btn-icon(v-if="peculiarities.btn.btnIcon"
							:class="peculiarities.btn.iconClass || ''"
							:icon="peculiarities.btn.btnIcon")
			.peculiarities__bottom
				.peculiarities__bottom-title(v-if="peculiarities.bonuses && peculiarities.bonuses.title") {{peculiarities.bonuses.title}}
				.peculiarities__bonuses-wrapper
					template(v-if="peculiarities.bonuses && peculiarities.bonuses.items && peculiarities.bonuses.items.length"
							v-for="(bonus, bonusIndex) in peculiarities.bonuses.items"
							:key="bonusIndex")
						.peculiarities__bonus-item
							.peculiarities__bonus-text(v-if="bonus.text") {{bonus.text}}
							.peculiarities__bonus-flag(v-if="bonus.flag") {{bonus.flag}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			peculiarities: null,
		};
	},

	methods: {
		openModal(text){
			controller.openModal({
				className: 'modal--mid',
				content: `<v-modal-window>${text}</v-modal-window>`
			});
		},

		dataSet(data) {
			this.peculiarities = data;
		}
	}
};
</script>